import { GET_USER_DETAILS, GET_USER_CHATGPT_CREDITS } from '../constants/actionTypes';

const INITIAL_STATE = {  userDetails: {}, errors: null };

export default function fetchUserDetails(state=INITIAL_STATE, action) {
  
  switch(action.type) {
    
    case GET_USER_DETAILS:
      return { ...state, data: action.payload.data.data, errors: null }
    case GET_USER_CHATGPT_CREDITS:
      return {...state, data:action.payload.data.data, error: null}
    default:
      return state;
  }
}
